import Api from './api';

export default {
  getAllAnnouncements: (page) => Api.get(`announcements?page=${page}`),
  getAnnouncementDetails: (id) => Api.get(`announcements/${id}`),
  createAnnouncement: (data) => Api.post('announcements', data),
  updateAnnouncement: (id, data) => Api.post(`announcements/${id}`, data),
  deleteAnnouncement: (id) => Api.delete(`announcements/${id}`),
};
